// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"EzevPRyN"};